import {
  HistoryMessageItem,
  MessageIncomingEvent,
  MessageOutgoingEvent,
  MessageStatusType,
  PinnedMessage,
} from '@wui/im'

const INCOMING_MESSAGE_TYPE = 9 as HistoryMessageItem['type']
const OUTGOING_MESSAGE_TYPE = 10 as HistoryMessageItem['type']

export const mapPinnedMessageToHistoryItem = (
  pin: PinnedMessage,
  roomPServed: string,
  currentUserImLogin?: string,
): HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent> => {
  const sender = pin.extendedParams?.sender ?? pin.pServedUserExecuter
  const isOutgoing = Boolean(currentUserImLogin && sender === currentUserImLogin)
  const messageText = pin.message ?? ''
  const files = pin.extendedParams?.files

  if (isOutgoing) {
    const item: MessageOutgoingEvent = {
      type: 'OutgoingMessageEvent',
      executor: sender,
      messageText,
      pServed: roomPServed,
      ...(files ? { files } : {}),
    }

    return {
      eventId: pin.eventId,
      rank: pin.rank,
      timestamp: pin.timestamp,
      status: MessageStatusType.ACCEPTED,
      type: OUTGOING_MESSAGE_TYPE,
      item,
    }
  }

  const item: MessageIncomingEvent = {
    type: 'IncomingMessageEvent',
    executor: sender,
    messageText,
    pServed: roomPServed,
    eventId: pin.eventId,
    rank: pin.rank,
    timestamp: pin.timestamp,
    ...(files ? { files } : {}),
  }

  return {
    eventId: pin.eventId,
    rank: pin.rank,
    timestamp: pin.timestamp,
    status: MessageStatusType.ACCEPTED,
    type: INCOMING_MESSAGE_TYPE,
    item,
  }
}
